import { NgModule } from '@angular/core';
import { provideConfig } from '../../../core/config/config-providers';

@NgModule({
  providers: [
    provideConfig({
      api: {
        endpoints: {
          // Public (auth:false) — the /support/mock-data page is unauthenticated,
          // and the FTE endpoint returns only non-sensitive fake test data.
          mockTestData: { path: 'test/mock/testdata', auth: false },
          // Authenticated artifact downloads (needs DOWNLOAD_ARTIFACTS; agent-desktop also
          // allows AGENT_DESKTOP_LOGIN). FTE resolves the environment-correct release channel.
          artifactDownload: { path: 'artifacts/<%= product %>/download' },
          artifactInfo: { path: 'artifacts/<%= product %>/info' },
        },
      },
    }),
  ],
})
export class SupportConfigModule {}
